// extracted by mini-css-extract-plugin
module.exports = {"container":"_dM","title":"_dN","tabs":"_dO","text":"_dP","textForm":"_dQ","submitButton":"_dR","checkboxContainer":"_dS","errorMessage":"_dT"};